import {
  createRootRoute,
  createRoute,
  createRouter,
  lazyRouteComponent,
} from '@tanstack/react-router'
import { RootLayout } from './root-layout'
import { ProtectedLayout } from './protected-layout'
import { NotFoundPage } from './not-found-page'
import { constructionPages } from './features/under-construction/construction-pages'
import { ShellPending } from './features/shell/pharmacy-shell'

const pharmacyLoading = {
  pendingComponent: ShellPending,
  pendingMs: 0,
  pendingMinMs: 0,
}

const root = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFoundPage,
})
const login = createRoute({
  getParentRoute: () => root,
  path: '/login',
  component: lazyRouteComponent(
    () => import('./features/auth/login-page'),
    'LoginPage',
  ),
})
const offline = createRoute({
  getParentRoute: () => root,
  path: '/offline',
  component: lazyRouteComponent(
    () => import('./features/offline/offline-page'),
    'OfflinePage',
  ),
})
const protectedRoute = createRoute({
  getParentRoute: () => root,
  id: '_protected',
  component: ProtectedLayout,
})
const dashboard = createRoute({
  ...pharmacyLoading,
  getParentRoute: () => protectedRoute,
  path: '/',
  staticData: { pharmacy: { title: 'Dashboard', mode: 'dashboard' } },
  component: lazyRouteComponent(
    () => import('./features/dashboard/dashboard-page'),
    'DashboardPage',
  ),
})
const pos = createRoute({
  ...pharmacyLoading,
  getParentRoute: () => protectedRoute,
  path: '/pos',
  staticData: { pharmacy: { title: 'POS / ขายหน้าร้าน', mode: 'pos' } },
  component: lazyRouteComponent(
    () => import('./features/pos/pos-page'),
    'PosPage',
  ),
})
const inventory = createRoute({
  ...pharmacyLoading,
  getParentRoute: () => protectedRoute,
  path: '/inventory',
  staticData: { pharmacy: { title: 'สินค้า', mode: 'inventory' } },
  component: lazyRouteComponent(
    () => import('./features/inventory/inventory-page'),
    'InventoryPage',
  ),
})
const constructionRoutes = constructionPages.map((page) =>
  createRoute({
    ...pharmacyLoading,
    getParentRoute: () => protectedRoute,
    path: page.path,
    staticData: { pharmacy: { title: page.label, mode: 'construction' } },
    component: lazyRouteComponent(
      () => import('./features/under-construction/under-construction-page'),
      'UnderConstructionPage',
    ),
  }),
)

export const router = createRouter({
  routeTree: root.addChildren([
    login,
    offline,
    protectedRoute.addChildren([
      dashboard,
      pos,
      inventory,
      ...constructionRoutes,
    ]),
  ]),
  defaultPreload: false,
})
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
